import dayjs, { Dayjs } from 'dayjs';

export const formatToCalendarLabel = (date: Dayjs): string => {
  return dayjs(date.toDate())
    .format('MMMM YYYY')
    .replace(/^./, (char) => char.toUpperCase());
};
